import { render, staticRenderFns } from "./Allergens.vue?vue&type=template&id=6c5e8244&scoped=true&"
import script from "./Allergens.vue?vue&type=script&lang=js&"
export * from "./Allergens.vue?vue&type=script&lang=js&"
import style0 from "./Allergens.vue?vue&type=style&index=0&id=6c5e8244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e8244",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VCheckbox,VFlex,VLayout,VTooltip})
